import { LegalPage, Section, Bullets, CONTACT_EMAIL } from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      title="Terms of Service"
      subtitle="The terms on which REAM may be accessed and used."
    >
      <Section heading="1. Acceptance">
        <p>
          REAM (Real Estate Asset Management) is private software operated for a landholding
          business to manage its own property records. By signing in, or by opening a read-only
          link shared with you, you agree to these terms. If you do not agree, do not use the
          platform.
        </p>
      </Section>

      <Section heading="2. Accounts and access">
        <Bullets items={[
          "Accounts are created only by an administrator; there is no public registration.",
          "You are responsible for keeping your password confidential and for everything done under your account.",
          "Administrators can view and manage the whole portfolio. Field executives can only access the properties assigned to them.",
          "Tell your administrator immediately if you believe your account has been compromised. Accounts may be suspended or removed at the owner's discretion.",
        ]} />
      </Section>

      <Section heading="3. Acceptable use">
        <Bullets items={[
          "Use the platform only for the property owner's legitimate asset-management purposes.",
          "Do not upload material you have no right to upload, or content that is unlawful, malicious or misleading.",
          "Do not fabricate site-visit evidence, tamper with capture timestamps or locations, or record inspections you did not carry out.",
          "Do not attempt to bypass access controls, probe the platform's security, scrape it in bulk, or use it to reach systems and cameras you are not authorised to access.",
          "Do not forward read-only sharing links beyond the recipient they were intended for.",
        ]} />
      </Section>

      <Section heading="4. Your records">
        <p>
          The property owner retains all rights in the records, documents, photographs and videos
          placed in REAM. We claim no ownership over them and process them only to run the platform,
          as described in the Privacy Policy. Exports, Excel registers, PDF reports and ZIP backups
          are provided so the owner always holds their own copy.
        </p>
      </Section>

      <Section heading="5. Site-visit evidence">
        <p>
          Inspection photographs and videos are stamped with the device's location and time as
          reported by that device. They are intended as a monitoring record and are not a survey,
          a legal boundary determination, or a substitute for a licensed surveyor's report.
        </p>
      </Section>

      <Section heading="6. Read-only sharing links">
        <p>
          An administrator may share a time-limited, read-only view of a single property with a bank,
          advocate or auditor. Recipients may view and download only the records included in that
          link, must keep the link confidential, and must not use the material for any purpose other
          than the one for which it was shared. Links expire automatically and may be revoked at any
          time without notice.
        </p>
      </Section>

      <Section heading="7. CCTV and third-party integrations">
        <p>
          Live camera viewing, Google Drive backups and email delivery depend on equipment and
          services operated by others — your cameras and network, Google, and the mail provider.
          You confirm you are authorised to connect any camera or account you configure, and you
          remain responsible for complying with the law that applies to recording and surveillance
          at your sites. We are not responsible for outages, quota limits, policy changes or data
          loss occurring within those third-party services.
        </p>
      </Section>

      <Section heading="8. Availability">
        <p>
          We aim to keep REAM available and reliable, but it is provided on an "as is" and "as
          available" basis without warranties of any kind. Maintenance, upgrades, connectivity
          problems or third-party failures may interrupt access. The platform is not a system of
          public record; official land records remain those maintained by the relevant government
          authority.
        </p>
      </Section>

      <Section heading="9. No professional advice">
        <p>
          Compliance indicators, litigation and mortgage entries, vaastu notes, renewal alerts,
          analytics and board reports are informational aids compiled from the data your team
          enters. They are not legal, valuation, taxation or investment advice. Verify anything
          material with a qualified professional before acting on it.
        </p>
      </Section>

      <Section heading="10. Limitation of liability">
        <p>
          To the maximum extent permitted by law, we are not liable for indirect, incidental or
          consequential loss, or for loss of profit, goodwill or data, arising from use of or
          inability to use the platform. Nothing in these terms limits liability that cannot be
          limited under applicable law.
        </p>
      </Section>

      <Section heading="11. Changes and termination">
        <p>
          These terms may be updated; the date at the top of this page shows when. Continued use
          after a change means you accept it. Access may be withdrawn if these terms are breached or
          if the owner ends your authorisation.
        </p>
      </Section>

      <Section heading="12. Governing law and contact">
        <p>
          These terms are governed by the laws of India, and the courts at Hyderabad, Telangana have
          exclusive jurisdiction. For any question about these terms, write to{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-primary hover:underline">{CONTACT_EMAIL}</a>.
        </p>
      </Section>
    </LegalPage>
  );
}
